import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from 'react-router-dom'
import { IconSprite, keepLatinDigits, ToastProvider } from '@metal/ui'
import { MarketClockProvider, SessionProvider } from '@metal/ui/session'
import { router } from '@/app/routes'
import '@metal/ui/styles.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Market data is T-1 and the board changes on the minute, not the
      // second. Refetching on every focus would show a busier market than
      // there is and would cost the user nothing but noise.
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        const status = (error as { status?: number }).status
        if (status && status >= 400 && status < 500) return false
        return failureCount < 2
      },
    },
  },
})

// Whatever keyboard types a figure, the value keeps a Latin one.
keepLatinDigits()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <IconSprite />
    <QueryClientProvider client={queryClient}>
      <SessionProvider onIdentityChange={() => queryClient.clear()}>
        <MarketClockProvider>
          <ToastProvider>
            <RouterProvider router={router} />
          </ToastProvider>
        </MarketClockProvider>
      </SessionProvider>
    </QueryClientProvider>
  </StrictMode>,
)
